import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from './common/form';
import { sendResetPassword } from '../actions/AuthActions';
import * as Validations from './common/form/commonValidations';

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.handleError = this.handleError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      error: false,
      errorMessage: ''
    };
  }

  onSubmit(values) {
    const { handleSubmit, setAuthState } = this.props;
    handleSubmit(values)
      .then((response) => {
        if (response.success) {
          setAuthState('forgotSuccess');
        } else {
          throw Error('Email not found');
        }
      })
      .catch(this.handleError);
  }

  handleError(error) {
    this.setState({ error: true, errorMessage: error.detailedMessage });
  }

  render() {
    const { setAuthState, pristine, submitting } = this.props;
    const { error, errorMessage } = this.state;
    return (
      <div>
        <div className="modal-header">
          <div className="zola-weddings-logo-black-100 center-block" />
          <h1 className="h1 text-center">Forgot Password</h1>
          <div className="help-block text-center">
            Enter your email address and we&#39;ll send you a link to change your password.
          </div>
        </div>
        <div className="modal-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                <form onSubmit={this.onSubmit}>
                  <Field
                    name="email"
                    type="email"
                    label="Email"
                    placeholder="Email"
                    id="login-email"
                    component={RenderField}
                    required
                    validate={[Validations.REQUIRED, Validations.EMAIL]}
                  />
                  <RenderSubmitButton pristine={pristine} submitting={submitting} valid value="Submit" className="btn-block" />
                </form>
                { error && (
                  errorMessage ? <div className="form-message-block text-center text-danger">{ errorMessage }</div>
                    : <div className="form-message-block text-center text-danger">There was a problem processing your request. <br />Please try again or contact <a href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer">customer support</a> for assistance.</div>) }
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="text-center">
            <a role="button" onClick={() => setAuthState('login')}>Login</a> / <a role="button" onClick={() => setAuthState('signup')}>Sign Up</a>
            <br /><br />
          </div>
        </div>
      </div>
    );
  }
}

ForgotPasswordForm.propTypes = {
  setAuthState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => (
  {
    onSubmit: ({ email }) => dispatch(sendResetPassword(email))
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'ForgotPasswordForm'
})(ForgotPasswordForm));



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm.jsx